module.exports = __webpack_public_path__ + "files/532a32234ef60aa02cfb492a2b44e24c.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-144x144.png
// module id = 1246
// module chunks = 76